import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

import './sass/main.scss'

import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective)

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app')
